import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import Layout from './components/layouts/Layout';
import { useEffect, useState } from 'react';
import SmoothScroll from './components/SmoothScroll';

function App() {

 

  return (
    <div className="App">
      

        <BrowserRouter>
        <SmoothScroll />
        <Routes>
          <Route path='/*' element={<Layout />}></Route>
        </Routes>
        </BrowserRouter>
    </div>
  );
}

export default App;
